// Removes the NZ locale segment from a Storyblok slug or pathname: a leading
// "en-nz/" or an "/en-nz" path segment. Segments merely containing "en-nz"
// (e.g. "xen-nz-thing") are left alone.
export function stripNzLocale(slug: string) {
  return slug.replace(/^en-nz\/|\/en-nz(?=\/|$)/, '')
}

export function storySlugFromPathname(pathname: string) {
  return stripNzLocale(pathname.replace(/^\/+|\/+$/g, ''))
}

// Builds a root-relative href from a story's full_slug, falling back to '#'
// when the slug is missing or not a string.
export function storyHref(fullSlug: string | undefined) {
  if (typeof fullSlug !== 'string' || fullSlug === '') return '#'
  return `/${stripNzLocale(fullSlug)}`
}
